module.exports = __webpack_public_path__ + "d4a5e5bf03d9b80745e04211de8e2d90.png";